/**
 * Created by slava on 02.02.17.
 */

/*
 * 1) problem with decorators !Completely replace cell by it's decorator
 * 2) bug with Game.animate counter !use only Game.currentGame.counter.setTimeout() in models
 * 3) event dependent css changes !Skins in views
 */

const Match3 = function (level, options) {
    GameBase.call(this, level, options);

    this.setupMissions();

    if (cleverapps.gameModes.newRules || this.level.getTag() === Level.TAGS.RULES) {
        Match3Rules = NewRules;
    } else {
        Match3Rules = CleverAppsHeroesRules;
    }

    this.loader = new Loader();

    ColorCookieManCell.exitToNextMove = ColorCookieManCell.amountToExit = 0;

    this.moves = this.savedGame.moves || this.levelContent.moves;
    if (this.royalLeagueMission && !this.savedGame.moves) {
        this.moves = RoyalLeagueLevelsAdapter.adjustMoves(this.moves);
    }
    if (this.hasDanger()) {
        this.dangerDuration = this.savedGame.dangerDuration || this.levelContent.dangerDuration;

        this.addDangerComponent();
        this.moves = -1;
    }

    this.leftMoves = this.savedGame.leftMoves || this.moves;
    this.beginMoves = this.savedGame.beginMoves || this.moves;
    this.moveMade = this.beginMoves !== this.moves;

    this.goals = new Goals(this.levelContent, this.savedGame.goals);
    this.field = new Field(this.loader, this.savedGame.field);

    this.started = false;
    this.on("beforeStartActions", () => {
        this.started = true;
    }, this);

    BaseAnimationFactories = {};

    this.boosters = new FieldBoosters();

    this.field.load(this.levelContent);

    this.counter.registerStage(0, this.checkWin.bind(this));
    this.counter.registerStage(99, ComboComponent.resetComboTargets);
    this.counter.registerStage(100, this.burn.bind(this));
    this.counter.registerStage(102, this.field.resetCoefs.bind(this.field));
    this.counter.registerStage(199, this.fall.bind(this));
    this.counter.registerStage(300, this.shuffle.bind(this));
    this.counter.registerStage(401, this.checkFinish.bind(this));
    this.counter.registerStage(410, this.explodeOnGameFinish.bind(this));
    this.counter.registerStage(430, this.tutorCompatibilityHint.bind(this));
    this.counter.registerStage(999, this.begin.bind(this));

    if (this.withIceMakerCell) {
        this.on("beforeStartActions", IceMakerCell.onGameStart);
        this.counter.registerStage(212, IceMakerCell.process);
    }

    if (this.withDirtyHoneyTile) {
        this.on("beforeStartActions", DirtyHoneyTile.onGameStart);
        this.counter.registerStage(211, DirtyHoneyTile.process);
    }

    if (this.withCandleCell) {
        this.on("beforeStartActions", CandleCell.onGameStart);
        this.counter.registerStage(150, CandleCell.applyIncGoal);
    }

    if (this.HOUSES) {
        this.on("beforeStartActions", GingerHouseCell.onGameStart);
    }

    if (this.withSharkCell) {
        this.on("beforeStartActions", SharkCell.onGameStart);
        this.counter.registerStage(213, SharkCell.process);
    }

    if (this.withIceBlockMakerTile) {
        this.on("beforeStartActions", IceBlockMakerTile.process);
        this.counter.registerStage(214, IceBlockMakerTile.process);
    }

    this.goalCounter = new Counter();
    this.goalCounter.registerStage(0, () => {
        this.counter.trigger();
    });

    this.onChangeMovesStateListener = function () {};
    this.onChangeMovesListener = function () {};
    this.onBoosterCellCollected = function () {};
    this.onAnimatedChangeMovesListener = function () {};

    this.start = undefined;
    this.field.on("touchMoved", this.onFieldTouchMoved.bind(this), this);
    this.field.on("touchEnded", this.onFieldTouchEnded.bind(this), this);
    this.field.on("move", this.onFieldMoved.bind(this), this);

    if (cleverapps.config.rpg) {
        this.enemies = Game.SelectEnemies(this.level);
    }

    if (cleverapps.config.name === "runes") {
        if (this.moves < 0) {
            this.moves = 100;
            this.leftMoves = this.moves;
            this.beginMoves = this.moves;
        }
        this.counter.registerStage(398, this.enemyAttackStage.bind(this));
        this.counter.registerStage(399, SharkCell.process);
    }

    this.onGetMovesView = function () {};

    BombCell.checkExplode();

    cleverapps.playSession.logEventOnce(cleverapps.EVENTS.HELP_BY_ATTEMPTS_DAU);
};

Game = Match3;

Match3.prototype = Object.create(GameBase.prototype);
Match3.constructor = Match3;

Match3.prototype.setupMissions = function () {
    if (!this.level.isRegular() || this.hasDanger() || this.level.isBonus()) {
        return;
    }

    const kingsCupMission = cleverapps.missionManager.findByType(Mission.TYPE_KINGSCUP);
    if (kingsCupMission && kingsCupMission.isRunning() && kingsCupMission.logic.isUnlocked()) {
        this.kingsCupMission = kingsCupMission;
    }

    const lightingRushMission = cleverapps.missionManager.findByType(Mission.TYPE_LIGHTNING_RUSH);
    if (lightingRushMission && lightingRushMission.isRunning() && lightingRushMission.logic.isActiveState()) {
        this.lightingRushMission = lightingRushMission;
    }

    const royalLeagueMission = cleverapps.missionManager.findByType(Mission.TYPE_ROYAL_LEAGUE);
    if (royalLeagueMission && royalLeagueMission.isRunning()) {
        this.royalLeagueMission = royalLeagueMission;
    }
};

Match3.prototype.getInfo = function () {
    const info = GameBase.prototype.getInfo.call(this);

    info.dangerDuration = this.dangerDuration;
    info.moves = this.moves;
    info.leftMoves = this.leftMoves;
    info.beginMoves = this.beginMoves;
    info.goals = this.goals.getInfo();
    info.field = this.field.getInfo();
    return info;
};

Match3.prototype.showScreen = function (f, silent) {
    this.boosters.trigger("show", true);
    this.trigger("showPanels", silent);

    cleverapps.focusManager.compound(f, [
        function (f) {
            this.goals.trigger("showUpAnimationStart", f, silent);
        }.bind(this),

        function (f) {
            this.field.trigger("showUpFloor", f, silent);
        }.bind(this),

        function (f) {
            this.field.showUpCells(f, silent);
        }.bind(this)
    ]);
};

Match3.prototype.showStartGameMessage = function (f, silent) {
    if (silent || this.levelWithTutorial()) {
        f();
        return;
    }

    if (this.level.isHard()) {
        cleverapps.effects.fire("match3.level.hard.open");
        this.showMessage("message.hardLevel", f);
        return;
    }

    cleverapps.exclamation.show("message.Letsgo", undefined, f);
};

Match3.prototype.getDailyCupStars = function () {
    return this.score.stars;
};

Match3.prototype.onMoveChangeMoves = function () {
    this.decMoves();
};

Match3.prototype.incMoves = function () {
    this.setMoves(this.moves + 1);
    this.leftMoves++;
};

Match3.prototype.decMoves = function () {
    this.setMoves(this.moves - 1);
    this.leftMoves--;
};

Match3.prototype.initColorCellsPool = function () {
    // create 10 elements each level color and add in pool
    for (let i = 0; i < this.levelContent.colors.length; i++) {
        let tmpCell = this.loader.loadNext(0, 0, [this.levelContent.colors[i]]);
        if (tmpCell && tmpCell.putInPoolAvailable && !cleverapps.gameModes.putInPoolDisabled) {
            const ViewClass = tmpCell.getViewClass();
            for (let j = 0; j < 10; j++) {
                if (j > 0) {
                    tmpCell = this.loader.loadNext(0, 0, [this.levelContent.colors[i]]);
                }
                cleverapps.pool.putInPool(new ViewClass(tmpCell));
            }
        }
    }
};

Match3.prototype.initPool = function () {
    FieldScoreView.fillPool();

    this.initColorCellsPool();

    ExplosionView.fillPool();
    CoefAnimation.fillPool();
    if (typeof ColorFulAnimationView !== "undefined") {
        ColorFulAnimationView.fillPool();
    }
    BombByLeftMovesAnimation.fillPool();
};

Match3.prototype.canHelpByFiveAttempts = function () {
    return cleverapps.user.checkAvailable(cleverapps.config.availables.HELP_BY_FIVE_ATTEMPTS) && this.field.getRandomMulticolorTo() !== false && !this.helpByFiveAttemptsDone;
};

Match3.prototype.helpByFiveAttempts = function () {
    if (!this.helpByFiveAttemptsDone) {
        this.helpByFiveAttemptsDone = 1;
        this.field.addRandomMulticolor();
        cleverapps.playSession.inc(cleverapps.EVENTS.HELP_BY_FIVE_ATTEMPTS);
        const amount = cleverapps.playSession.get(cleverapps.EVENTS.HELP_BY_FIVE_ATTEMPTS);
        if (amount >= 1) {
            cleverapps.playSession.logEventOnce(cleverapps.EVENTS.HELP_BY_ATTEMPTS_ONE_AND_MORE);
        }
        if (amount >= 3) {
            cleverapps.playSession.logEventOnce(cleverapps.EVENTS.HELP_BY_ATTEMPTS_THREE_AND_MORE);
        }
        if (amount >= 5) {
            cleverapps.playSession.logEventOnce(cleverapps.EVENTS.HELP_BY_ATTEMPTS_FIVE_AND_MORE);
        }
    }
};

Match3.prototype.onFieldTouchMoved = function (cell) {
    if (this.boosters.active) {
        this.boosters.active.onFieldTouchMoved(cell);
        return;
    }
    if (this.field.selected) {
        if (this.field.selected.onMouseMove) {
            this.field.selected.onMouseMove(cell);
        }
    }
};

Match3.prototype.onFieldTouchEnded = function (cell) {
    if (!cell) {
        return;
    }

    if (cell.movable && this.field.selected && this.field.canMove(this.field.selected, cell)) {
        const dir = {
            row: cell.y - this.field.selected.y,
            col: cell.x - this.field.selected.x
        };
        this.tryMove(dir);
    } else {
        const component = cell.findComponent && cell.findComponent([MuffinComponent, GoalCoefComponent]);
        if (cell.smile) {
            cell.smile();
        } else if (component && component.smile) {
            component.smile();
        }
        this.field.select(cell);
        this.field.debugHighlightCells(cell);
    }

    cell.onTouchEnd();
};

Match3.prototype.tryMove = function (dir, fromPos) {
    let from = this.field.selected;
    if (fromPos) {
        from = this.field.cells[fromPos.row] ? this.field.cells[fromPos.row][fromPos.col] : undefined;
    }

    if (!from) {
        return;
    }

    const toCol = from.x + dir.col;
    const toRow = from.y + dir.row;

    if (!this.field.isWithinBounds(toRow, toCol) || !Match3TutorialHelper.checkTutorialCell(cc.p(toCol, toRow))) {
        return;
    }

    const to = this.field.cells[toRow][toCol];

    if (!to) {
        return;
    }

    const isMovable = function (cell) {
        return cell.movable && !cell.controlDisabled;
    };

    if (!isMovable(from)) {
        from.animate(BaseCell.ANIMATION_MISTAKE);
        return;
    }

    if (!isMovable(to)) {
        this.field.invalidMove(from, to);
        return;
    }

    const isValidMove = this.field.isValidMove(from, dir);
    if (isValidMove === false) {
        return;
    }

    const finish = this.field.cells[from.y + dir.row][from.x + dir.col];

    if (isValidMove === true) {
        this.field.move(from, finish);
    } else {
        // (isValidMove === undefined)
        this.field.wrongMove(from, finish);
    }

    return true;
};

Match3.prototype.onFieldMoved = function () {
    this.moveInProgress = true;
    this.moveMade = true;

    if (this.moves > 0) {
        this.onMoveChangeMoves();

        if (this.outcome === GameBase.OUTCOME_UNKNOWN && BoosterCell.isNeedToAdd(this.moves, this.beginMoves)) {
            this.field.pushNextCell(BoosterCell);
        }
        if (this.outcome === GameBase.OUTCOME_UNKNOWN && KingsCupCell.isNeedToAdd(this.moves, this.beginMoves)) {
            this.field.pushNextCell(KingsCupCell);
        }
    }
    this.updateOneTimePerMoveFeatures();
    this.field.prepareResetCoefs();
};

Match3.MOVES_STATE_NORMAL = 0;
Match3.MOVES_STATE_DANGER = 1;

Match3.prototype._setMoves = function (moves, options) {
    if (this.goals.isDone || (moves > 5 && this.moves <= 5)) {
        this.onChangeMovesStateListener(Match3.MOVES_STATE_NORMAL);
    } else if (!this.goals.isDone && moves <= 5 && this.moves > 5) {
        this.onChangeMovesStateListener(Match3.MOVES_STATE_DANGER);
    }

    const movesDiff = moves - this.moves;
    this.moves = moves;
    this.onChangeMovesListener(moves, movesDiff, options);
};

Match3.prototype.setMoves = function (moves, options) {
    const getMoves = typeof moves === "function" ? moves : () => moves;
    let actualMoves = getMoves();

    options = options || {};
    if (options.silent) {
        this._setMoves(actualMoves, options);
        return;
    }
    if (options.animate) {
        this.onAnimatedChangeMovesListener(actualMoves - this.moves, options, this._setMoves.bind(this, actualMoves, options));
    } else {
        this.counter.setTimeout(() => {
            options.delay = 0;

            actualMoves = getMoves();
            this._setMoves(actualMoves, options);

            if (options.bonus) {
                for (let i = 0; i < options.bonus; i++) {
                    this.field.addRandomMulticolor();
                }
            }
        }, options.delay || 0);
    }
};

Match3.prototype.stop = function () {
    this.field.smile.stop();

    this.boosters.stop();

    GameBase.prototype.stop.call(this);
};

Match3.prototype.checkWin = function () {
    if (this.goals.isDone && this.outcome === GameBase.OUTCOME_UNKNOWN) {
        this.win();
    }
};

Match3.prototype.checkOutcome = function () {
    if (this.outcome === GameBase.OUTCOME_UNKNOWN || cleverapps.focusManager.isFocused()) {
        return;
    }

    if (this.goalCounter && this.goalCounter.isActive()) {
        return;
    }

    const actions = [];
    if (this.hasDanger()) {
        actions.push((f) => {
            const sceneComponent = cleverapps.Scenes.GetSceneComponent(Match3SceneComponent);
            sceneComponent.showDangerButton(this.outcome, f);
        });
    }

    this.goals.whenCollectsFinished(() => {
        new ActionPlayer(actions).play(() => {
            this.trigger("haveOutcome", this.outcome);
        });
    });
};

Match3.prototype.updateOneTimePerMoveFeatures = function () {
    this.dirtDecoratorCellCanProcess = true;
    this.crabDecoratorCellCanProcess = true;
    this.crabMakerCellCanProcess = true;
    this.dirtMakerCellCanProcess = true;
    this.lollipopCellCanProcess = true;
    this.dirtyHoneyTileCanProcess = true;
    this.iceMakerCellCanProcess = true;
    this.sharkCellCanProcess = true;
    this.iceBlockMakerTileCanProcess = true;
    this.cannonCellCanProcess = true;
    this.smallPetardCellCanProcess = true;
    CookieManCell.prepareToUp();
    ColorCookieManCell.prepareToUp();
    TransporterTile.prepareToMove();
    SharkCell.prepareToProcess();
    CandleCell.prepare();
    BombCell.prepareToProcess();
};

Match3.prototype.tutorCompatibilityHint = function () {
    if (this.goalCounter.isActive() || this.outcome !== GameBase.OUTCOME_UNKNOWN) {
        return;
    }

    // required only to recalculate PseudoRandom.GET().state for tutors
    PseudoRandom.GET().nextInt();
};

Match3.prototype.onExecuteBooster = function () {
    this.cannonCellCanProcess = true;
};

Match3.prototype.checkFinish = function () {
    if (this.goalCounter.isActive()) {
        return;
    }
    if (this.outcome === GameBase.OUTCOME_VICTORY) {
        this.score.addGoalFinished = true;
        return;
    }

    if (this.outcome === GameBase.OUTCOME_UNKNOWN) {
        this.handleFinish();
    }
};

Match3.prototype.handleFinish = function () {
    if (this.dangerComponent && this.dangerComponent.isFinished() && !this.goals.isDone) {
        this.handleExpiredTime();
    } else if (this.moveInProgress) {
        this.moveInProgress = false;

        if (!this.goals.isDone) {
            if (this.moves === 0) {
                this.handleNoMoves();
            } else if (this.moves <= 5) {
                this.trigger("lowMoves", this.moves);
            }
        }
    }
};

Match3.prototype.handleExpiredTime = function () {
    this.lose();
};

Match3.prototype.handleNoMoves = function () {
    if (this.loseByBombExplodeRunning) {
        return;
    }
    if (this.level.isBonus()) {
        this.win();
    } else {
        this.trigger("outOfMoves");
    }
};

Match3.prototype.shakeField = function (params) {
    this.field.trigger("shakeField", params);
};

Match3.prototype.explodeOnGameFinish = function () {
    if (this.goalCounter.isActive()) {
        return;
    }
    if (this.goals.isDone) {
        this.field.onGameFinish();
    }
};

Match3.prototype.hasBombByLeftMovesAnimation = function () {
    return ["heroes"].indexOf(cleverapps.config.name) !== -1 && this.goals.isDone && this.moves > 0;
};

Match3.prototype.bombByLeftMoves = function (f) {
    this.field.bombByLeftMoves(this.moves, f);
};

Match3.prototype.bigExplode = function () {
    if (this.outcome !== GameBase.OUTCOME_UNKNOWN) {
        return;
    }

    if (this.tutorial && !this.tutorial.finished) {
        return;
    }

    const msg = PseudoRandom.GET().mathChoose(cleverapps.exclamation.getCongratulations());
    cleverapps.exclamation.show(msg, Exclamation.Types.Congrats);
};

Match3.prototype.burn = function () {
    if (this.outcome !== GameBase.OUTCOME_UNKNOWN) {
        return;
    }
    for (let i = 0; i < Field.SIZE; i++) {
        for (let j = 0; j < Field.SIZE; j++) {
            if (this.field.cells[i][j]) {
                this.field.cells[i][j].onBurnStage();
            }
        }
    }

    const shapes = this.field.findAllShapes();

    if (shapes.length === 0) {
        return;
    }

    if (!this.field.lastMove) {
        cleverapps.effects.fire("match3.cascade");
    }

    shapes.forEach((shape) => {
        shape.cells.forEach((cell) => {
            cell.prepareForBurn();
        });
    });

    SyrupTile.enableProcess();
    shapes.forEach(function (shape) {
        let boomCoef;
        const center = shape.getCenter();

        const shapeForm = shape.calculateForm();

        if (Match3Rules.Plus) {
            boomCoef = 1;

            switch (shapeForm) {
                case Shape.FOUR_V:
                case Shape.FOUR_H:
                case Shape.BOMB:
                    boomCoef = 2;
                    break;
            }
        }

        if (center.findComponent(GoalCoefComponent) || center.innerCell && center.innerCell.findComponent(GoalCoefComponent)) {
            let score = 0;
            shape.cells.forEach((cell) => {
                const goalCoefComponent = cell.findComponent(GoalCoefComponent);
                if (goalCoefComponent) {
                    score++;
                }
                if (goalCoefComponent && goalCoefComponent.coef) {
                    score += goalCoefComponent.coef;
                }
            });
            this.field.trigger("addScore", score, center.getColor(), center.x, center.y);
        }

        shape.cells.sort((a, b) => {
            if (cleverapps.resolution.mode === cleverapps.WideMode.HORIZONTAL) {
                if (a.x !== b.x) {
                    return a.x - b.x;
                }
                return a.y - b.y;
            }
            if (a.y !== b.y) {
                return a.y - b.y;
            }
            return a.x - b.x;
        });

        shape.cells.forEach(function (cell, id) {
            const params = {
                id,
                groupSize: shape.cells.length
            };

            if (cell === center && center.lives <= 1 && center.lives >= 0 && !center.innerCell) {
                const combo = ComboComponent.Create(center, {
                    shape
                });

                if (combo) {
                    shape.merge({
                        target: center,
                        duration: 0.2,
                        filter: function (cell) {
                            return cell.movable && !cell.controlDisabled && cell.lives === 1 && !(cell instanceof HeroCell);
                        }
                    });

                    params.callback = function () {
                        Game.currentGame.counter.setTimeout(() => {
                            this.field.addCell(combo);
                            combo.animate(BaseCell.ANIMATION_CREATE);
                        }, 200);
                    }.bind(this);
                }
            }

            if (Match3Rules.Plus) {
                cell.boomNeighbors(boomCoef);
            } else {
                cell.boomNeighbors();
            }
            Game.currentGame.counter.setTimeout(() => {
                cell.hurt(params);
            }, 200);
        }, this);

        RugTile.process(shape.cells);
        SyrupTile.process(shape.cells);
    }, this);

    this.field.lastMove = undefined;
};

Match3.prototype.fall = function () {
    if (this.outcome !== GameBase.OUTCOME_UNKNOWN) {
        return;
    }
    this.field.markNotWillFall();

    const didFall = this.field.replenishGaps((x, y) => this.field.createRandomCell(x, y));

    if (didFall) {
        this.counter.onceZero = this.fall.bind(this);
    }

    this.field.animateDidFallNotWillFall();

    if (cleverapps.config.debugMode) {
        this.field.trigger("debugHighlightCells", []);
    }
};

Match3.prototype.shuffle = function () {
    if (this.outcome !== GameBase.OUTCOME_UNKNOWN) {
        return;
    }

    return this.field.shuffle();
};

Match3.prototype.addBoosterCellReward = function (boosterCell) {
    this.rewards[GameBase.REWARD_BOOSTERS] = {};
    this.rewards[GameBase.REWARD_BOOSTERS][boosterCell.type] = 1;
    cleverapps.metrics.logEvent(cleverapps.EVENTS.BOOSTER_CELL_COLLECTED);
    this.onBoosterCellCollected();
};

Match3.prototype.addDangerComponent = function () {
    this.dangerComponent = new DangerComponent(this.dangerDuration);
};

Match3.prototype.getPercentOfCompletion = function () {
    let target = 0, amount = 0;
    const elements = this.goals.elements;
    for (const type in elements) {
        target += elements[type].target;
        amount += Math.min(elements[type].amount, elements[type].target);
    }
    return amount / target;
};

Match3.prototype.needBonusByLeftMoves = function () {
    return this.hasBombByLeftMovesAnimation();
};

Match3.prototype.hideField = function (f) {
    this.counter.clearStages();
    this.field.trigger("hide", f);
};

Match3.prototype.animateBonus = function (f) {
    const actions = [];

    if (this.hasBombByLeftMovesAnimation()) {
        this.on("onSkip", f);
        actions.push(this.bombByLeftMoves.bind(this));
    }

    new ActionPlayer(actions).play(f);
};

Match3.BIG_EXPLODE_AMOUNT = 9;